var getResolution = require('../utils/getResolution');
var checkPointNotInRotatedImage = require('../utils/checkPointNotInRotatedImage');

function checkDecimals(settings) {
  var positions = settings.decimals.positions;
  if (settings.decimals.enabled === 0 && settings.data.valueToUse === 0) {
    throw new Error('valueToUse = 0 but pointers not enabled');
  }
  if (positions) {
    var resolution = getResolution(settings);
    for (var i = 0; i < positions.length; i++) {
      var pos = positions[i].coords;
      if (pos) {
        if (checkPointNotInRotatedImage(pos.x, pos.y, resolution.width, resolution.height, settings.orientation)) {
          throw new Error('Pointer position outside image range (' + pos.x + ',' + pos.y + ')');
        }
      }
    }
  } else {
    if (settings.decimals.enabled === 1) {
      throw new Error('Pointers enabled but none configured');
    }
  }
}

module.exports = checkDecimals;


//////////////////
// WEBPACK FOOTER
// ./~/@smartvatten/flowone-settings-check/checks/decimals.js
// module id = 849
// module chunks = 0